import { gql } from '@apollo/client';

export const GET_APP_CONFIG = gql(/* GraphQL */ `
    query GetAppConfig {
        appConfig {
            financialYearStartMonth
            maintenanceMode
            maintenanceMessage
            surveyAutoGenEnabled
            surveyAutoGenDueDays
            vatPercentage
            divisionManagerApprovalSlaMinutes
            opsExecApprovalSlaMinutes
            seniorOpsExecApprovalSlaMinutes
            procurementManagerApprovalSlaMinutes
            procurementExecApprovalSlaMinutes
            procurementSupplierEngagementSlaMinutes
            androidAppVersion
            iosAppVersion
            huaweiAppVersion
            appUpdateRequired
            appUpdateMessage
            excludedCountryCodes
            excludedDivisionSapIds
            dailyIncompleteSalesReportRecipients
            dmOpsDeclineReasons
            procurementDeclineReasons
            supplierDeclineReasons
            interimPriceReasons
            salesReviewEnabled
            manualSalesAutoDataMaxAgeHours
            pendingPriceChangeRequestsDigestHours
            divisionalManagerPendingPriceChangeRequestsDigestHours
            divisionalManagerPriceChangeRequestOutcomesDigestHours
            storeManagerPriceChangeRequestOutcomesDigestHours
            pricingBatchesModuleEnabled
            priceChangeFreezeStartAt
            priceChangeFreezeEndAt
            priceChangeFreezeBannerMessage
            priceChangeFreezeIsActive
            salesDataMaintenanceStartTime
            salesDataMaintenanceEndTime
            salesDataMaintenanceIsActive
            salesDataMaintenanceEndsAt
            letsCreatePriceSyncEnabled
            trainingModuleEnabled
        }
    }
`);
